import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, NavLink, useParams, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
//Utils 
import { RenderIf } from '../utils/RenderIf';
import { checkUserModules } from "../utils/CheckUserModules";
import { useSbLayout } from "../../context/LayoutContext";

import logo from "../../assets/img/logos/icon-black.png";
import { toSbNav } from "./sb-nav.data.js";

import "./sidebar.css";
import ModalLanguage from "../NavBar/ModalLanguage.jsx";
import OldVersionButton from "../Oldversionbutton/Oldversionbutton.jsx";

// Devuelve true si el item (o alguno de sus hijos, de forma recursiva) corresponde
// a la ruta actualmente activa. Se usa tanto para resaltar el link activo como
// para mantener expandidos sus grupos/subgrupos padres.
function navItemHasActiveDescendant(item, pathname) {
  if (!item) return false;
  if (item.type === "link") return item.href === pathname;
  if (item.type === "group") {
    return (item.children || []).some((child) => navItemHasActiveDescendant(child, pathname));
  }
  return false;
}

// Render recursivo de un item del menú: soporta N niveles de anidación
// (link simple, o grupo expandible con hijos que a su vez pueden ser grupos).
function renderNavItem(item, { pathname, expandedItems, toggleNavItem }) {
  if (item.type === "link") {
    const isActive = item.href === pathname;
    return (
      <div className="sb-nav-item" key={item.id}>
        <a href={item.href || "#"} className={`sb-nav-link ${isActive ? "sb-active" : ""}`}>
          <i className={item.icon} />
          <span className="sb-nav-link-text">{item.label}</span>
        </a>
      </div>
    );
  }

  if (item.type === "group") {
    const hasActiveDescendant = navItemHasActiveDescendant(item, pathname);
    // El grupo se mantiene expandido si el usuario lo abrió manualmente,
    // o si alguna de las rutas activas vive dentro de él.
    const isExpanded = expandedItems.includes(item.id) || hasActiveDescendant;

    return (
      <div className={`sb-nav-item ${isExpanded ? "sb-expanded" : ""}`} key={item.id}>
        <div
          className={`sb-nav-link ${hasActiveDescendant ? "sb-active" : ""}`}
          onClick={() => toggleNavItem(item.id)}
        >
          <i className={item.icon} />
          <span className="sb-nav-link-text">{item.label}</span>
          <i className="fas fa-chevron-right sb-nav-arrow" />
        </div>

        <div className="sb-nav-nested">
          {item.children?.map((child) => renderNavItem(child, { pathname, expandedItems, toggleNavItem }))}
        </div>
      </div>
    );
  }

  return null;
}

export default function Sidebar( { route } ) {
  const {
    collapsed,
    mobileOpen,
    expandedItems,
    profileOpen,
    profileRef,
    toggleMobileSidebar,
    toggleNavItem,
    toggleProfileMenu,
  } = useSbLayout();

  // const navSections = useMemo(() => SB_NAV, []);


  const [outLogShow, setOutLogShow] = useState(false);

  //Params
  let { business_code } = useParams();
  let user = localStorage.getItem('user')
  let options = []
  const navigate = useNavigate();
  const location = useLocation();


  //We valilink if the user is logged in
  if (user === null || user === undefined || user === '') {
    user = {
      name: 'No registrado',
      img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
    }
  } else {
    user = JSON.parse(localStorage.getItem('user'))
  }


  function signout() {
    //We delete the token 
    localStorage.setItem('x-access-token', "");
    localStorage.removeItem('user');
    localStorage.removeItem('branchoffice_selected');
    localStorage.removeItem('branchoffice');
    //We check the role of the user and depending of it we redirect 
    if (user.role.find(element => element.role_id === 7 || element.role_id === 6 || element.role_id === 3 || element.role_id === 8 || element.role_id >= 9) !== undefined) {
      if (new URL(window.location.href).hostname === process.env.REACT_APP_DASHBOARD_URL) {
        navigate(`/login/${business_code}`)
      } else {
        navigate(`/`)
      }
    }
  }


  const menuMain = useMemo(() => {
    return [
      {
        title: 'Vision General',
        icon: 'fa-solid fa-circle-nodes',
        link: `/overview/${business_code}`,
        integrationOption: false,
        permition: checkUserModules('product_module', user.modules) !== -1
          || checkUserModules('inventory_module', user.modules) !== -1
          || checkUserModules('buy_module', user.modules) !== -1 ? true : false,


      },
      {
        title: 'Operaciones ',
        icon: "uil uil-dashboard",
        subtitle: ['Transacciones', 'Precuentas'],
        link: ``,
        integrationOption: false,
        permition: checkUserModules('pay_module', user.modules) !== -1
          || checkUserModules('preaccount_module', user.modules) !== -1 ? true : false,
        items: [
          {
            title: 'Transacciones',
            description: "Pagos en tiempo real",
            icon: 'uil uil-bill',
            link: `/transactions_panel/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('pay_module', user.modules) === -1 ? false : true,
          },

          {
            title: 'Precuentas',
            description: "Resumen preliminar del consumo de un cliente",
            icon: 'uil uil-invoice ',
            link: `/precuentas_panel/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('preaccount_module', user.modules) === -1 ? false : true

          },

        ]
      },

      {
        title: 'Stock',
        icon: 'uil uil-database-alt',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('product_module', user.modules) !== -1
          || checkUserModules('inventory_module', user.modules) !== -1
          || checkUserModules('buy_module', user.modules) !== -1 ? true : false,

        items: [
          // {
          //   title: 'Productos',
          //   description: "Gestión y creación de artículos y elementos para sus sucursales",
          //   icon: 'uil  uil-shopping-bag ',
          //   link: `/products/${business_code}`,
          //   integrationOption: false,
          //   permition: checkUserModules('product_module', user.modules) === -1 ? false : true

          // },
          {
            title: 'Panel de productos',
            description: "Gestión y creación de artículos y elementos para sus sucursales",
            icon: 'uil  uil-shopping-bag ',
            link: `/product_panel/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('product_module', user.modules) === -1 ? false : true

          },
          {
            title: 'Inventario',
            description: "Listado de productos o bienes disponibles en stock",
            icon: 'uil uil-box',
            link: `/new_inventory/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('inventory_module', user.modules) === -1 ? false : true
          },

          {
            title: 'Compras',
            description: "Adquisición de productos para abastecer sus sucursales",
            icon: 'uil uil-shopping-cart',
            link: `/new_buys/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('buy_module', user.modules) === -1 ? false : true

          },
        ]
      },


      {
        title: 'Análisis',
        icon: 'uil uil-chart-line ',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('analitics_module', user.modules) !== -1
          || checkUserModules('report_module', user.modules) !== -1 ? true : false,

        items: [

          {
            title: 'Analíticas',
            icon: 'uil uil-arrow-growth',
            description: "Visualización de datos sobre pagos, sucursales y transacciones",
            link: `/new_analitics/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('analitics_module', user.modules) === -1 ? false : true
          },
          // {
          //   title: 'Reportes',
          //   icon: 'uil uil-file-graph',
          //   description: "Muestra de resultados clave y análisis",
          //   link: `/reports/${business_code}`,
          //   integrationOption: false,
          //   permition: checkUserModules('report_module', user.modules) === -1 ? false : true

          // },
          {
            title: "Panel de reportes",
            icon: 'uil uil-presentation',
            description: "Visualización de datos sobre pagos, sucursales y transacciones",
            link: `/report_panel/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('report_module', user.modules) === -1 ? false : true
          }
        ]
      },

      {
        title: 'Gestión',
        icon: 'uil uil-sliders-v',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('users_module', user.modules) !== -1
          || checkUserModules('event_module', user.modules) !== -1
          || checkUserModules('table_module', user.modules) !== -1
          || checkUserModules('notification_module', user.modules) !== -1 ? true : false,
        items: [
          {
            title: 'Usuarios',
            description: "Gestión y creación de usuarios",
            icon: 'uil uil-user-square ',
            link: `/new_users/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('users_module', user.modules) === -1 ? false : true

          },

          {
            title: 'Eventos',
            icon: 'uil uil-calendar-alt ',
            description: "Gestión y creación de eventos",
            link: `/new_events/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('event_module', user.modules) === -1 ? false : true
          },
          {
            title: user.business.business_type.panamanianCode !== "9010" ? "Habitaciones" : "Mesas",
            icon: user.business.business_type.panamanianCode !== "9010" ? "uil uil-bed-double" : 'uil uil-restaurant',
            description: `Administración y creación de ${user.business.business_type.panamanianCode !== "9010" ? "habitaciones" : "mesas"}`,
            link: ``,
            integrationOption: false,
            permition: checkUserModules('table_module', user.modules) === -1 ? false : true,
            items: [
              {
                title: 'Listado',
                icon: user.business.business_type.panamanianCode !== "9010" ? "uil uil-bed-double" : 'uil uil-restaurant',
                description: `Administración y creación de ${user.business.business_type.panamanianCode !== "9010" ? "habitaciones" : "mesas"}`,
                link: `/new_tables/${business_code}`,
                integrationOption: false,
                permition: checkUserModules('table_module', user.modules) === -1 ? false : true
              },
              {
                title: 'Solicitudes',
                icon: 'uil uil-clipboard-notes',
                description: `Solicitudes de acceso a ${user.business.business_type.panamanianCode !== "9010" ? "habitaciones" : "mesas"} enviadas desde el ecommerce`,
                link: `/new_tables/requests/${business_code}`,
                integrationOption: false,
                permition: checkUserModules('table_module', user.modules) === -1 ? false : true
              },
            ]
          },
          {
            title: "Clientes",
            icon: 'uil uil-users-alt',
            description: `Administración de clientes`,
            link: `/new_clients/${business_code}`,
            integrationOption: false,
            permition: true
          },


          {
            title: 'Notificaciones',
            description: "Envío de mensajes de clientes a la plataforma de administración",
            icon: 'uil uil-bell',
            link: `/new_notifications/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('notification_module', user.modules) === -1 ? false : true
          },
        ]
      },

      {
        title: 'Integraciones',
        icon: 'uil uil-cloud-data-connection',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('webhook_module', user.modules) !== -1
          || checkUserModules('pos_integrations_module', user.modules) !== -1 ? true : false,

        items: [
          {
            title: ' Webhook',
            icon: 'uil uil-channel',
            description: "Integración de servicios externos",
            link: `/new_webhook/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('webhook_module', user.modules) === -1 ? false : true

          }
        ]

      },

      {
        title: 'Equipos',
        icon: 'uil uil-robot',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('machine_module', user.modules) !== -1
          || checkUserModules('vending_module', user.modules) !== -1 ? true : false,
        items: [

          {
            title: 'Máquinas',
            icon: 'uil uil-desktop',
            description: "Dispositivos con licencias que habilitan funciones específicas en la plataforma",
            link: `/new_machines/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('machine_module', user.modules) === -1 ? false : true
          },
          {
            title: 'Vending',
            description: "Máquinas automáticas expendedoras de productos como alimentos o bebidas",
            icon: 'uil uil-web-section-alt',
            link: `/new_vending/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('vending_module', user.modules) === -1 ? false : true

          },


        ]

      },


      {
        title: "Finanzas",
        icon: 'uil uil-money-bill',
        link: ``,
        integrationOption: false,
        permition: true,
        items: [
          {
            title: 'Conciliación bancaria',
            icon: 'uil uil-building',
            description: "Agrupa varios créditos, proceso contable que compara los registros contables de una empresa con los movimientos bancarios. ",
            link: `/bank/new_consiliation/${business_code}`,
            integrationOption: false,
            permition: true
          },
        ]
      },
      {
        title: "Promociones",
        icon: 'uil  uil-percentage',
        link: ``,
        integrationOption: false,
        permition: checkUserModules('cupon_module', user.modules) !== -1 ? true : false,
        items: [

          {
            title: "Cupones",
            icon: 'uil uil-ticket',
            description: "Códigos o vales que ofrecen descuentos o beneficios en productos o servicios",
            link: `/new_cupons/${business_code}`,
            integrationOption: false,
            permition: checkUserModules('cupon_module', user.modules) === -1 ? false : true
          },

        ]

      },

      {
        title: "Configuraciones",
        icon: 'uil uil-wrench',
        link: ``,
        integrationOption: false,
        permition: true,
        items: [
          {
            title: 'Cliente frecuente',
            icon: 'uil uil-grin-tongue-wink-alt',
            description: "Maneja los puntos que se asignaran a los clientes frecuentes",
            link: `/config/new_frecuent-client/${business_code}`,
            integrationOption: false,
            permition: true
          },
          {
            title: 'Ecommerce',
            icon: 'uil uil-store',
            description: "Gestión y configuración de la tienda en línea",
            link: `/config/new_ecommerce/${business_code}`,
            integrationOption: false,
            permition: true
          },
          {
            title: "Delivery",
            icon: 'uil uil-truck',
            description: "Gestión y configuración del servicio de entrega a domicilio",
            link: `/config/new_delivery/${business_code}`,
            integrationOption: false,
            permition: true
          },
          {
            title: "Pick & Go",
            icon: 'uil uil-grin',
            description: "Gestión y configuración del servicio de recogida en tienda",
            link: `/config/new_pick-and-go/${business_code}`,
            integrationOption: false,
            permition: true
          }
        ]
      },

    ];
  }, [user, business_code, checkUserModules]);


  const navSections = useMemo(() => toSbNav(menuMain, { user, business_code }), [menuMain, user, business_code]);


  //We check if the user has permissions to see the integrations menu
  if (user.business.posIntegrations !== undefined) {
    //We check if the user has permissions to see the integrations menu
    let integrations = user.business.posIntegrations
    //We check if the user has permissions to see the integrations menu
    if (integrations.length > 0) {
      integrations.map((integration) => {
        menuMain[4].items.push({
          title: integration.pos_integration_id !== null && integration.pos_integration_id !== undefined ? integration.name : 'Ninguna integración',
          icon: 'uil uil-monitor ',
          description: integration.name + " - " + integration.vertion,
          link: `/manager/integration/${business_code}/${integration.name}/${integration.pos_integration_id}`,
          integrationOption: true,
          permition: checkUserModules('pos_integrations_module', user.modules) !== -1 && user.business.posIntegrations.length > 0 ? true : false
        })
      })
    }
  }


  return (
    <>
      {/* Mobile Toggle */}
      <button className="sb-mobile-toggle" onClick={toggleMobileSidebar} type="button">
        <i className="fas fa-bars" />
      </button>

      <div
        className={`sb-mobile-overlay ${mobileOpen ? "sb-active" : ""}`}
        onClick={toggleMobileSidebar}
      />

      <aside className={`sb-sidebar ${collapsed ? "sb-collapsed" : ""} ${mobileOpen ? "sb-mobile-open" : ""}`}>
        {/* Header */}
        <div className="sb-sidebar-header">
          <div className="sb-logo-container">
            <div className="sb-logo">
              <img src={logo} alt="logo Smart Pay" className="sb-logo" />
            </div>
            <div className="sb-company-info">
              <div className="sb-company-name">Smart Pay</div>
            </div>
          </div>
        </div>

        {/* Navigation (DATA-DRIVEN, MISMO MARKUP/CLASES) */}
        {/* <nav className="sb-sidebar-nav">
          {navSections.map((section) => (
            <div className="sb-nav-section" key={section.sectionTitle}>
              <div className="sb-nav-section-title">{section.sectionTitle}</div>

              {section.items?.map((item) => {
                // Link simple
                if (item.type === "link") {
                  return (
                    <div className="sb-nav-item" key={item.id}>
                      <a href={item.href || "#"} className={`sb-nav-link ${item.defaultActive ? "sb-active" : ""}`}>
                        <i className={item.icon} />
                        <span className="sb-nav-link-text">{item.label}</span>
                      </a>
                    </div>
                  );
                }

                // Grupo expandable
                if (item.type === "group") {
                  const isExpanded = expandedItems.includes(item.id);

                  return (
                    <div className={`sb-nav-item ${isExpanded ? "sb-expanded" : ""}`} key={item.id}>
                      <div className="sb-nav-link" onClick={() => toggleNavItem(item.id)}>
                        <i className={item.icon} />
                        <span className="sb-nav-link-text">{item.label}</span>
                        <i className="fas fa-chevron-right sb-nav-arrow" />
                      </div>

                      <div className="sb-nav-nested">
                        {item.children?.map((child) => (
                          <a key={child.id} href={child.href || "#"} className="sb-nav-link">
                            {child.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  );
                }

                return null;
              })}
            </div>
          ))}
        </nav> */}

        {/* Navigation (renderizado desde tu menuMain) */}
        <nav className="sb-sidebar-nav">
          {navSections.map((section) => (
            <div className="sb-nav-section" key={section.sectionTitle}>
              <div className="sb-nav-section-title">{section.sectionTitle}</div>

              {section.items?.map((item) =>
                renderNavItem(item, { pathname: location.pathname, expandedItems, toggleNavItem })
              )}
            </div>
          ))}
        </nav>

        <OldVersionButton route={route} />

        {/* Profile */}
        <div className="sb-profile-card" ref={profileRef}>
          <div className="sb-profile-trigger" onClick={toggleProfileMenu}>




            <div className="sb-profile-avatar"><i class="uil uil-user-circle"></i></div>
            <div className="sb-profile-info">
              <div className="sb-profile-name">{user.name}</div>
              <div className="sb-profile-email">Cargo </div>
            </div>
            <i className="fas fa-chevron-up sb-profile-menu-icon" />
          </div>

          <div className={`sb-profile-dropdown ${profileOpen ? "sb-active" : ""}`}>
            <a href="#" className="sb-dropdown-item"><i className="fas fa-user" />Perfil</a>
            {/* <ModalLanguage></ModalLanguage> */}
            <a href="#" className="sb-dropdown-item sb-danger" onClick={() => signout()} ><i className="fas fa-sign-out-alt" />Cerrar Sesión </a>
          </div>
        </div>
      </aside>
    </>
  );
}
